module.exports = __webpack_public_path__ + "img/title-benefits.2c1d0d18.svg";